module.exports = __webpack_public_path__ + "img/icon_box_2_2.a8fcecc3.png";